export default "/assets/site/images/teke.jpg?707bfdefebf73d9e0e2cefe3657583de";